const Api = "https://proxyadmin.sdbufeng.vip"
// const Api = "http://proxy_bf.php8.test"

const login = "/api/member/login"  //登录
const getSmsCode = "/api/member/sendMessage"  //验证码
const signinCode = "/api/member/signinCode"  //短信登录
const register = "/api/member/register"  //注册
const readProductList = "/api/member/readProductList"  //获取产品信息
const readArticlesList = "/api/article/readArticlesList"  //读取文章列表  7:help
const cdkey = "/official/cdkey"  //卡密充值
const aliPay = "/official/aliPay"  //支付宝支付
const readMemberInfo = "/api/member/queryUserInfo"  //获取用户信息
const logout = "/api/member/logout"  //退出登录
const readRechargeList = "/api/member/getRechargeList"  //读取充值记录
const readProductOrderList = "/official/readProductOrderList"  //读取消费记录
const updPassword = "/api/member/updPassword"  //修改密码
const getBannerList = "/api/article/getBannerList"  //获取banner图
const readAreaList = "/api/member/readAreaList"  //读取地区列表
const readConsumeCountList = "/official/readConsumeCountList"  //读取消费统计(共享消费)
const readPackageList = "/official/readPackageList"  //获取套餐列表
const upload = "/api/member/upload"  //上传
const authRealname = "/official/authRealname"  //实名认证
const authCompany = "/api/member/authCompany"  //企业认证
const updIpWhite = "/api/member/updIpWhite"  //修改白名单
const readPackageOrderList = "/official/readPackageOrderList"  //获取独享订单
const checkMemberPackage = "/official/checkMemberPackage"  //购买前检测是否有套餐
const buyPackage = "/official/buyPackage"  //购买独享套餐
const readAPIMold = "/api/member/readAPIMold"  //获取api
const enterprise = "/api/member/enterprise"  //填写企业信息
const getCHCurrencyList = "/official/getCHCurrencyList"  //充值列表
const getauthcode = "/official/getauthcode"  //新实名认证
const getauthstatus = "/official/getauthstatus"  //认证检测

const readShowArticleImg = "/api/article/readShowArticleImg"  //新帮助中心热门文章图例
const readHotArticleList = "/api/article/readHotArticleList"  //新帮助中心高点击量文章
const readArticleInfo = "/api/article/readArticleInfo"  //新帮助中心读取文章详情
const readCategoryList = "/api/article/readCategoryList"  //新帮助中心读取分类列表
const readArticleTitleList = "/api/article/readArticleTitleList"  //新帮助中心搜索文章标题结果
const getfree = "/official/getfree"  //领取免费币
const isgetfree = "/official/isgetfree"  //领取免费状态
const getPrivacyPolicy = "/api/article/getPrivacyPolicy"  //用户隐私协议
const getServiceTerms = "/api/article/getServiceTerms"  //网站服务条款

//new
const imgCaptcha = "/api/member/imgCaptcha"  //生成图片验证码
const getConsumeList = "/api/member/getConsumeList"  //消费记录
const getMyPackageList = "/api/member/getMyPackageList"  //获取个人信息中我的套餐（分页）

const getMyProductList = "/api/member/getMyProductList"  //获取API 查询套餐列表接口
const getAuthUrl = "/api/alipay/getAuthUrl"  //个人实名认证
const getAboutUs = "/api/article/getAboutUs"  //页面信息获取
const orderShort = "/api/order/orderShort"  //短效套餐下单
const orderExclusive = "/api/order/orderExclusive"  //独享套餐下单
const deposit = "/api/order/deposit"  //充值

const queryAuth = "/api/member/queryAuth"  //实名认证查询
const getAgreement = "/api/article/getAgreement"  //获取协议
const queryOrder = "/api/order/queryOrder"  //消费查询

const Apis = {
  imgCaptcha: Api + imgCaptcha,
  getConsumeList: Api + getConsumeList,
  getMyPackageList: Api + getMyPackageList,
  getAgreement: Api + getAgreement,
  getMyProductList: Api + getMyProductList,
  getAuthUrl: Api + getAuthUrl,
  getAboutUs: Api + getAboutUs,
  queryAuth: Api + queryAuth,
  queryOrder: Api + queryOrder,
  login:Api + login,
  getSmsCode:Api + getSmsCode,
  register:Api + register,
  signinCode:Api + signinCode,
  readProductList:Api + readProductList,
  readArticlesList:Api + readArticlesList,
  cdkey:Api + cdkey,
  aliPay:Api + aliPay,
  readMemberInfo:Api + readMemberInfo,
  logout:Api + logout,
  readRechargeList:Api + readRechargeList,
  readProductOrderList:Api + readProductOrderList,
  updPassword:Api + updPassword,
  getBannerList:Api + getBannerList,
  readAreaList:Api + readAreaList,
  readConsumeCountList:Api + readConsumeCountList,
  readPackageList:Api + readPackageList,
  upload:Api + upload,
  authRealname:Api + authRealname,
  authCompany:Api + authCompany,
  updIpWhite:Api + updIpWhite,
  readPackageOrderList:Api + readPackageOrderList,
  checkMemberPackage:Api + checkMemberPackage,
  buyPackage:Api + buyPackage,
  readAPIMold:Api + readAPIMold,
  enterprise:Api + enterprise,
  getCHCurrencyList:Api + getCHCurrencyList,
  getauthcode:Api + getauthcode,
  getauthstatus:Api + getauthstatus,
  readShowArticleImg:Api + readShowArticleImg,
  readHotArticleList:Api + readHotArticleList,
  readArticleInfo:Api + readArticleInfo,
  readCategoryList:Api + readCategoryList,
  readArticleTitleList:Api + readArticleTitleList,
  getfree:Api + getfree,
  isgetfree:Api + isgetfree,
  getPrivacyPolicy:Api + getPrivacyPolicy,
  getServiceTerms:Api + getServiceTerms,
  orderShort:Api + orderShort,
  orderExclusive:Api + orderExclusive,
  deposit:Api + deposit,
  
  
}

export { Apis };